import { render, staticRenderFns } from "./aboutUsFooter.vue?vue&type=template&id=7ed77096&"
import script from "./aboutUsFooter.vue?vue&type=script&lang=js&"
export * from "./aboutUsFooter.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsFooter.vue?vue&type=style&index=0&id=7ed77096&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports